import StopColors from '../StopColors';
import Percentage from './Percentage';
import Circle from './Circle';
import Legend from './Legend';
import { type CircleChartData } from 'src/shared/types/charts';
import { RootWrapper, SvgCircleWithPctWrapper } from './styles';

type SingleChartProps = {
  data: CircleChartData;
};

const SingleChart = ({ data }: SingleChartProps) => {
  return (
    <RootWrapper data-testid={`single-chart-${data.id}`}>
      <div className="flex-wrapper">
        <div className="single-chart">
          <SvgCircleWithPctWrapper viewBox="0 0 36 36">
            <defs>
              <linearGradient id={`gradient-${data.id}`} x1="8.95%" y1="106.5%" x2="91.05%" y2="-6.5%">
                <StopColors colors={data?.color} />
              </linearGradient>
            </defs>
            <Circle id={data.id} value={data.value} />
            <Percentage value={data.value} />
          </SvgCircleWithPctWrapper>
          {data.legend && <Legend colors={data?.color} legend={data.legend} explanation={data?.explanation} />}
        </div>
      </div>
    </RootWrapper>
  );
};

export default SingleChart;
